export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11588.05c72c22.jpg";